// 02.3-client.md paso b -- extraído de `renderObservaciones` en SubPanelTratos.jsx.
// Presentacional: sin `clientApi`/hooks/toast -- toda la data y los `on*` vienen por props.
// Estilos inline preservados verbatim (conversión a tokens es el paso `e`).
export default function ObservacionField({ field, text, isOk, isPublic, isExpanded, onToggleExpand, onToggleOk, onChangeText }) {
    const hasText = (text || '').trim().length > 0;

    if (isPublic) {
        if (!hasText) return null;
        return (
            <div style={{ position: 'relative', marginTop: 0, marginBottom: 'var(--space-4)' }}>
                <div style={{ position: 'absolute', top: 0, right: '15px', transform: 'translateY(-50%)', background: isOk ? '#10b981' : '#ef4444', color: '#fff', fontSize: '9px', padding: '2px var(--space-2)', borderRadius: 'var(--radius-sm)', fontWeight: 'bold', textTransform: 'uppercase', zIndex: 10 }}>
                    Observaciones
                </div>
                <textarea
                    value={text || ''}
                    readOnly
                    aria-label={`Observaciones de ${field}`}
                    style={{ width: '100%', background: '#0a0a0c', color: '#fff', fontSize: '11px', padding: 'var(--space-3)', border: `1px solid ${isOk ? '#10b981' : '#ef4444'}`, borderRadius: '0 0 var(--radius-md) var(--radius-md)', borderTop: 'none', resize: 'none', display: 'block', outline: 'none' }}
                />
            </div>
        );
    }

    return (
        <div style={{ position: 'relative', marginTop: 0, marginBottom: isExpanded ? '15px' : 0 }}>
            <div style={{ position: 'absolute', top: 0, right: '15px', transform: 'translateY(-50%)', display: 'flex', alignItems: 'center', gap: 'var(--space-2)', zIndex: 10 }}>
                <div
                    onClick={(e) => { e.stopPropagation(); onToggleExpand(); }}
                    style={{ background: hasText ? '#ef4444' : '#6b7280', color: '#fff', fontSize: '9px', padding: '2px var(--space-2)', borderRadius: 'var(--radius-sm)', fontWeight: 'bold', textTransform: 'uppercase', cursor: 'pointer', transition: 'background 0.2s' }}
                >
                    Observaciones
                </div>
                <div
                    onClick={(e) => { e.stopPropagation(); onToggleOk(); }}
                    style={{ width: '16px', height: '16px', borderRadius: '50%', background: isOk ? '#10b981' : 'rgba(255,255,255,0.1)', border: '1px solid #10b981', color: isOk ? '#fff' : '#10b981', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', transition: 'all 0.2s' }}
                    title="Marcar como verificado/listo"
                >
                    <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg>
                </div>
            </div>
            {isExpanded && (
                <textarea
                    value={text || ''}
                    onChange={(e) => onChangeText(e.target.value)}
                    placeholder="Escribe una observación..."
                    aria-label={`Observaciones de ${field}`}
                    style={{ width: '100%', background: '#0a0a0c', color: '#fff', fontSize: '11px', padding: 'var(--space-3)', border: '1px solid #333', borderTop: 'none', borderRadius: '0 0 var(--radius-md) var(--radius-md)', minHeight: '60px', display: 'block', outline: 'none', resize: 'vertical' }}
                />
            )}
        </div>
    );
}
